import React from 'react';
import { motion } from 'framer-motion';
export function Programs() {
  const programs = [{
    title: 'Speed & Agility Program',
    description: '4-week competitive, high-energy training experience. Build explosive speed, enhance footwork, and increase stamina.'
  }, {
    title: 'Homeschool P.E. Program',
    description: 'ESA-approved year-round PE every Tuesday & Friday. A new sport each month to build skills and teamwork.'
  }, {
    title: 'After School P.E. Program',
    description: 'Structured after-school athletic development for students of all abilities. Focus on fundamentals and fitness.'
  }];
  return <section id="programs" className="py-20 md:py-28 bg-white" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-sep-charcoal uppercase" data-id="element-202">
            CURRENT PROGRAMS
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-24 h-1.5 bg-sep-red mx-auto mt-6" data-id="element-203"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-204">
          {programs.map((program, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 flex flex-col h-full" data-id="element-205">
              <div className="h-2 w-full bg-sep-red" data-id="element-206"></div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-207">
                <h3 className="font-heading font-bold text-2xl text-sep-charcoal mb-4" data-id="element-208">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-8 flex-grow" data-id="element-209">
                  {program.description}
                </p>
                <a href="#contact" className="text-sep-red font-bold uppercase tracking-wide hover:text-sep-red-dark transition-colors inline-flex items-center group" data-id="element-210">
                  Learn More
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-211">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-212" />
                  </svg>
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}